import React from 'react';
import { IconArrowBack } from '@bynder/icons';
import { CSRF } from '../../helpers/csrf';

const AUTH_URL = '/user/reauthenticate/';

export function Impersonate() {
	return (
		<div className="unit-switch-container">
			<form className="clearfix" action={AUTH_URL} method="post">
				<input type="hidden" name="csrf" value={CSRF} />
				<button type="submit" className="btn-adminbar" tabIndex={4}>
					<IconArrowBack size="14px" /> Exit impersonate
				</button>
			</form>
		</div>
	);
}
